// Libs
import { memo } from "react";
// Types
import { ChartNames } from "../../Libs/Types/ChartTypes";
// Utils
import { ChartRenderer } from "../../Libs/Utils/chartUtils";

const GetChart = memo(function GetChart({
  chartName,
  chartValue,
  dataKey,
  isHorizontal,
}: {
  chartName: ChartNames;
  chartValue: any;
  dataKey: string;
  isHorizontal?: boolean;
}) {
  if (chartValue !== null) {
    return new ChartRenderer(chartName, chartValue).renderChart(
      dataKey,
      isHorizontal
    );
  }
});

export default function Charts() {
  let chartsData = null;
  try {
    chartsData = require("../../mockData");
  } catch (error) {
    chartsData = null;
  }
  return (
    <div className="grid grid-cols-12 gap-3 mb-2">
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="BarChart"
          chartValue={chartsData !== null ? chartsData.chartsData["BarChart"] : null}
          isHorizontal={true}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="BarChart"
          chartValue={chartsData !== null ? chartsData.chartsData["BarChart2"] : null}
          isHorizontal={false}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="GaugeChart"
          chartValue={chartsData !== null ? chartsData.chartsData["GaugeChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="AreaChart"
          chartValue={chartsData !== null ? chartsData.chartsData["AreaChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="BubbleChart"
          chartValue={chartsData !== null ? chartsData.chartsData["BubbleChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="BoxChart"
          chartValue={chartsData !== null ? chartsData.chartsData["BoxChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="CandleStickChart"
          chartValue={
            chartsData !== null ? chartsData.chartsData["CandleStickChart"] : null
          }
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="DoughnutChart"
          chartValue={chartsData !== null ? chartsData.chartsData["DoughnutChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="FunnelChart"
          chartValue={chartsData !== null ? chartsData.chartsData["FunnelChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="HeatmapChart"
          chartValue={chartsData !== null ? chartsData.chartsData["HeatmapChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="HistogramChart"
          chartValue={chartsData !== null ? chartsData.chartsData["HistogramChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="LineChart"
          chartValue={chartsData !== null ? chartsData.chartsData["LineChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="PieChart"
          chartValue={chartsData !== null ? chartsData.chartsData["PieChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="RadarChart"
          chartValue={chartsData !== null ? chartsData.chartsData["RadarChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-5 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="ScatterChart"
          chartValue={chartsData !== null ? chartsData.chartsData["ScatterChart"] : null}
          dataKey="0"
        />
      </div>
      <div className="col-span-12 lg:col-span-7 bg-white rounded-lg shadow-lg">
        <GetChart
          chartName="TreeMapChart"
          chartValue={chartsData !== null ? chartsData.chartsData["TreeMapChart"] : null}
          dataKey="0"
        />
      </div>
    </div>
  );
}
